// extracted by mini-css-extract-plugin
module.exports = {"btn":"ExamEditor_btn_1zYY0","forminput":"ExamEditor_forminput_3LdIa","numberinput":"ExamEditor_numberinput_umb1O"};